import { render, staticRenderFns } from "./ModalActivityNote.vue?vue&type=template&id=bcd4b2e4&scoped=true&"
import script from "./ModalActivityNote.vue?vue&type=script&lang=ts&"
export * from "./ModalActivityNote.vue?vue&type=script&lang=ts&"
import style0 from "./ModalActivityNote.vue?vue&type=style&index=0&id=bcd4b2e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd4b2e4",
  null
  
)

export default component.exports